import { jsx as _jsx } from "react/jsx-runtime";
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { PlacesOfPerformanceTab } from '../tabs/PlacesOfPerformanceTab';
export function PlacesPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsx(PlacesOfPerformanceTab, {
            programId: programId
        })
    });
}
